export default class FieldsSettings {
  public static readonly INDIVIDUAL_ROLE_PREFIX: string = 'INDIVIDUAL_ROLE_HINTS.';
  public static readonly ORGANIZATION_TYPE_PREFIX: string = 'ORGANIZATION_TYPE_HINTS.';
}
